import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultProcessArtifactResource,
    ProcessArtifactMutationResourceSchema,
    type ProcessArtifactResource,
    useProcessArtifactActions,
} from '../../../../../resource/resources/artifacts/process_artifact/processArtifactResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ProcessArtifactContent } from './ProcessArtifactContent';

export const ProcessArtifactCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ProcessArtifactResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const processArtifactActions = useProcessArtifactActions();
    const addProcessArtifact = processArtifactActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProcessArtifactMutationResourceSchema,
        defaultValues: {
            ...defaultProcessArtifactResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addProcessArtifact.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Process Artifact'}
            resourceType={ResourceType.PROCESS_ARTIFACT}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ProcessArtifactContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
